import * as React from "react";
import styles from "./PopoverPane.scss";

interface IProps {
    children?: React.ReactNode[] | React.ReactNode;
    className?: string;
}

export class PopoverPane extends React.Component<IProps> {
    constructor(props: IProps) {
        super(props);
    }

    public render() {
        return (
            <div className={`${styles.popoverPane} ${this.props.className}`}>
                {this.props.children}
            </div>
        );
    }
}

export default PopoverPane;


// WEBPACK FOOTER //
// ./src/Components/Common/Popover/PopoverPane/PopoverPane.tsx